import React, { useState, useEffect } from "react";
import { Form, Typography, message, Modal } from "antd";
import http from "../../../../../services/http";
import { FilePdfOutlined } from "@ant-design/icons";
import { RenderPdf } from "../../../../../components/renderPdf";
const { Text } = Typography;

export function ModalPdf({ id, open, onClose }) {
	const [form] = Form.useForm();
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		carregarMaterialArquivo(id);
	}, [id]);

	// CARREGAR ARQUIVO
	const carregarMaterialArquivo = async (id) => {
		if (!id) return;
		setLoading(true);
		const api = await http("file", `v1/treinamentos_materiais/carregar_arquivo/${id}`, []);
		if (api.statusCode === 200) {
			const response = api?.response?.data;

			// CRIAR ARQUIVO PDF
			var blob = new Blob([response], {
				type: "application/pdf",
			});

			setData(window.URL.createObjectURL(blob));
		} else {
			onClose();
			message.error(api.response.message);
		}
		setLoading(false);
	};

	return (
		<Modal
			title={
				<Text style={{ fontSize: 20 }}>
					<FilePdfOutlined /> Documento
				</Text>
			}
			open={open}
			onOk={() => form.submit()}
			okText="Salvar"
			width={1200}
			bodyStyle={{ height: 650 }}
			okButtonProps={{ style: { display: "none" } }}
			cancelButtonProps={{ size: "large", loading: loading }}
			onCancel={() => {
				setData(null);
				onClose();
			}}>
			<RenderPdf file={data} />
		</Modal>
	);
}
